import { Injectable } from '@angular/core';

import { DealershipService } from './dealership.service';
import { SummaryService } from './summary.service';
import type { TSummary } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class MenuService {
    private summarySubscription: any;
    private hasAllSettingsData = false;

    constructor(private dealershipService: DealershipService, private summaryService: SummaryService) {
    }

    public async initialize(): Promise<void> {
        const observable = this.summaryService.getObservable();
        this.summarySubscription = observable.subscribe((summary: TSummary) => {
            this.computeHasAllSettingsData();
        });
    }

    public cleanup(): void {
        this.summarySubscription.unsubscribe();
    }

    private async computeHasAllSettingsData(): Promise<void> {
        const dealershipDefined = await this.doesDealershipProfileDataExist();
        
        const summary = await this.summaryService.getByUid('overallSummary') as TSummary;
        const serviceAreasCount = summary?.numServiceAreas || 0;
        const shuttlesCount = summary?.numShuttles || 0;
        const usersCount = summary?.numUsers || 0;

        this.hasAllSettingsData = dealershipDefined && 
                                    (serviceAreasCount >= 1) && 
                                    (shuttlesCount >= 1) && 
                                    (usersCount >= 3);
    }

    private async doesDealershipProfileDataExist(): Promise<boolean> {
        const dealership = await this.dealershipService.get();

        const hasDealershipName = !!dealership?.dealershipName?.trim();
        const hasAddress = !!dealership?.address;
        const hasFullAddress = !!dealership?.address?.fullAddress?.trim();
        const hasPhoneNumber = !!dealership?.phoneNumber?.trim();
        const hasCountry = !!dealership?.address?.countryName?.trim();

        const hasAllDealershipData = hasDealershipName && hasAddress && hasFullAddress && 
                hasPhoneNumber && hasCountry;
        return hasAllDealershipData;
    }

    public getHasAllSettingsData(): boolean {
        return this.hasAllSettingsData;
    }
}
